var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 3.83333C10.8334 3.3731 10.4603 3 10.0001 3C9.53984 3 9.16675 3.3731 9.16675 3.83333V17.1667C9.16675 17.6269 9.53984 18 10.0001 18C10.4603 18 10.8334 17.6269 10.8334 17.1667V3.83333Z",
    fill: "#808085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 8C15.4603 8 15.8334 8.3731 15.8334 8.83333V17.1667C15.8334 17.6269 15.4603 18 15.0001 18C14.5398 18 14.1667 17.6269 14.1667 17.1667V8.83333C14.1667 8.3731 14.5398 8 15.0001 8Z",
    fill: "#808085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 11.3333C5.46032 11.3333 5.83341 11.7064 5.83341 12.1667V17.1667C5.83341 17.6269 5.46032 18 5.00008 18C4.53984 18 4.16675 17.6269 4.16675 17.1667V12.1667C4.16675 11.7064 4.53984 11.3333 5.00008 11.3333Z",
    fill: "#808085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandles);
export default __webpack_public_path__ + "static/media/candles.cd421da3.svg";
export { ForwardRef as ReactComponent };